import { Toaster } from 'sonner';
import { useResolvedTheme } from '@/Hooks/useTheme';

/**
 * Sonner paints its own surface and does not read our CSS variables, so it has
 * to be told which theme it is in. Left on `'light'` it puts a white slab over
 * a #080604 page — the one thing a dark theme exists to prevent.
 */
export function ThemedToaster() {
  return <Toaster position="top-center" richColors closeButton theme={useResolvedTheme()} />;
}
